import moment from 'moment';

const startOfYear = moment().startOf('year').format('DD-MM-YYYY');
const endOfYear = moment().endOf('year').format('DD-MM-YYYY');

const startOfWeek = moment().startOf('week').format('DD-MM-YYYY');
const endOfWeek = moment().endOf('week').format('DD-MM-YYYY');

const startOfMonth = moment().startOf('month').format('DD-MM-YYYY');
const endOfMonth = moment().endOf('month').format('DD-MM-YYYY');

const previousStartYear = moment().subtract(1, 'year').startOf('year').format('DD-MM-YYYY');
const previousEndYear = moment().subtract(1, 'year').endOf('year').format('DD-MM-YYYY');

const previousTwoStartYear = moment().subtract(2, 'year').startOf('year').format('DD-MM-YYYY');
const previousTwoEndYear = moment().subtract(2, 'year').endOf('year').format('DD-MM-YYYY');

// hospitality Format
const hospitalityStartOfYear = moment().startOf('year').format('YYYY-MM-DD');
const hospitalityEndOfYear = moment().endOf('year').format('YYYY-MM-DD');

const hospitalityStartOfWeek = moment().startOf('week').format('YYYY-MM-DD');
const hospitalityEndOfWeek = moment().endOf('week').format('YYYY-MM-DD');

const hospitalityStartOfMonth = moment().startOf('month').format('YYYY-MM-DD');
const hospitalityEndOfMonth = moment().endOf('month').format('YYYY-MM-DD');

const hospitalityPreviousStartYear = moment()
  .subtract(1, 'year')
  .startOf('year')
  .format('YYYY-MM-DD');
const hospitalityPreviousEndYear = moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD');

const hospitalityPreviousTwoStartYear = moment()
  .subtract(2, 'year')
  .startOf('year')
  .format('YYYY-MM-DD');
const hospitalityPreviousTwoEndYear = moment()
  .subtract(2, 'year')
  .endOf('year')
  .format('YYYY-MM-DD');

const formatList = [
  '',
  'YYYY-MM-DDTHH:mm:ssZ',
  'MM/DD/YYYY HH:mm',
  'DD/MM/YYYY HH:mm',
  'DD-MM-YYYY HH:mm'
];
export const formatDateAndTime = (dateTime: string) => {
  let date;
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateTime)) {
    const [DD, MM, YYYY] = dateTime.split('-').map(Number);
    date = new Date(YYYY, MM - 1, DD); // Month is 0-based
  } else {
    date = new Date(dateTime); // Try native parsing for ISO or valid formats
  }

  if (isNaN(date.getTime())) {
    throw new Error('Invalid date format');
  }
  const pad = (num: any) => num.toString().padStart(2, '0');

  const MM = pad(date.getMonth() + 1);
  const DD = pad(date.getDate());
  const YYYY = date.getFullYear();
  const HH = pad(date.getHours());
  const mm = pad(date.getMinutes());
  const ss = pad(date.getSeconds());
  let formattedDateTime = '';
  const format = sessionStorage.getItem('dateTimeFormat');
  const formatType = formatList.findIndex((ele) => ele === format);
  switch (formatType) {
    case 1:
      formattedDateTime = `${YYYY}-${MM}-${DD}T${HH}:${mm}:${ss}Z`;
      break;
    case 2:
      formattedDateTime = `${MM}/${DD}/${YYYY} ${HH}:${mm}`;
      break;
    case 3:
      formattedDateTime = `${DD}/${MM}/${YYYY} ${HH}:${mm}`;
      break;
    case 4:
      formattedDateTime = `${DD}-${MM}-${YYYY} ${HH}:${mm}`;
      break;
    default:
      return '';
  }
  return formattedDateTime;
};

export const formatBookingDate = (dateString: string) => {
  const format = sessionStorage.getItem('dateTimeFormat') || 'YYYY-MM-DDTHH:mm:ssZ';

  const dateParts = dateString.split(',').map((datePart) => datePart.trim());

  const formattedDates = dateParts.map((datePart) => {
    let parsedDate = null;
    let hasTime = false;

    if (/\d{2}-\d{2}-\d{4} \d{2}:\d{2}/.test(datePart)) {
      parsedDate = moment(datePart, 'DD-MM-YYYY HH:mm');
      hasTime = true;
    } else if (/\d{2}-\d{2}-\d{4}/.test(datePart)) {
      parsedDate = moment(datePart, 'DD-MM-YYYY');
    }

    if (!parsedDate || !parsedDate.isValid()) {
      return null;
    }

    const finalFormat = hasTime ? format : format.split(' ')[0];

    return parsedDate.local().format(finalFormat);
  });

  return formattedDates.join(', ');
};

export default {
  startOfWeek,
  startOfMonth,
  startOfYear,
  endOfMonth,
  endOfWeek,
  endOfYear,
  previousStartYear,
  previousEndYear,
  previousTwoStartYear,
  previousTwoEndYear,
  hospitalityStartOfYear,
  hospitalityEndOfYear,
  hospitalityStartOfWeek,
  hospitalityEndOfWeek,
  hospitalityStartOfMonth,
  hospitalityEndOfMonth,
  hospitalityPreviousStartYear,
  hospitalityPreviousEndYear,
  hospitalityPreviousTwoStartYear,
  hospitalityPreviousTwoEndYear
};
